/**
 * sentry.js — optional Sentry init.
 *
 * Set REACT_APP_SENTRY_DSN in Vercel env vars to enable. If unset,
 * this file is a no-op and the dashboard runs without telemetry.
 *
 * Free tier: 5K errors/month. Plenty for current scale.
 *
 * Why dynamic import: Sentry's SDK is ~50KB gzipped. Loading it only
 * when configured keeps the bundle small for users who don't enable it.
 */

export async function initSentry() {
  const dsn = process.env.REACT_APP_SENTRY_DSN;
  if (!dsn) {
    return;
  }
  try {
    const Sentry = await import("@sentry/react");
    Sentry.init({
      dsn,
      environment: process.env.NODE_ENV || "production",
      tracesSampleRate: 0.1,
      replaysSessionSampleRate: 0,
      replaysOnErrorSampleRate: 0,
      beforeSend(event) {
        // Strip anything that looks like PHI from breadcrumbs.
        // Patient names/IDs can leak through error messages from API calls.
        if (event.request?.url) {
          event.request.url = event.request.url.replace(/\/patients\/[^/?]+/g, "/patients/[id]");
        }
        return event;
      },
    });
    // Expose to ErrorBoundary for componentDidCatch
    window.Sentry = Sentry;
  } catch (e) {
    console.warn("Sentry SDK failed to load:", e);
  }
}
